import validate from "/usr/src/rt-details-2023/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45activation_45token_45handler_45global from "/usr/src/rt-details-2023/middleware/00-activation-token-handler.global.ts";
import _01_45route_45handler_45global from "/usr/src/rt-details-2023/middleware/01-route-handler.global.ts";
import _02_45nuxt_45server_45init_45global from "/usr/src/rt-details-2023/middleware/02-nuxt-server-init.global.ts";
import auth_45global from "/usr/src/rt-details-2023/middleware/auth.global.ts";
import frontiers_45impact_45global from "/usr/src/rt-details-2023/middleware/frontiers-impact.global.ts";
export const globalMiddleware = [
  validate,
  _00_45activation_45token_45handler_45global,
  _01_45route_45handler_45global,
  _02_45nuxt_45server_45init_45global,
  auth_45global,
  frontiers_45impact_45global
]
export const namedMiddleware = {}